import { LoaderFunction, useFetcher } from "react-router-dom";
import {
  getCourses,
  getDepartments,
  getSections,
  getTerms,
} from "../../../../../common/api/decimal/methods/verba.ts";
import { DecimalResult } from "../../../../../common/api/decimal/utils.ts";

interface CommonResult {
  id: string;
  name: string;
}

export const coursePickerLoader: LoaderFunction = ({
  params,
}): Promise<DecimalResult<CommonResult[]>> => {
  const { term, department, course } = params;

  if (course) {
    return getSections(term!, department!, course);
  }

  if (department) {
    return getCourses(term!, department);
  }

  if (term) {
    return getDepartments(term);
  }

  return getTerms();
};

export const useCoursePickerFetcher = () => {
  return useFetcher<DecimalResult<CommonResult[]>>();
};
